<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
/**
 * Advanced table component
 */
export default {
  page: {
    title: "Statement",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Payment Methods",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Payment Methods",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "amountin",
          sortable: true,
          label: "AMOUNT IN",
        },
        {
          key: "amountout",
          sortable: true,
          label: "AMOUNT OUT",
        },
        {
          key: "date",
          sortable: true,
          label: "DATE",
        },
        {
          key: "mode",
          sortable: true,
          label: "MODE",
        },
        {
          key: "desc",
          sortable: true,
          label: "DESCRIPTION",
        },
        {
          key: "cat",
          sortable: true,
          label: "TYPE",
        },
      ],
      modeName: "",
      data: {
        from: "",
        to: moment(new Date()).format("YYYY-MM-DD"),
      },

      id: atob(this.$route.params.id),
    };
  },
  computed: {
    ...mapGetters("modes", ["Statement", "SaveStatus"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.Statement ? this.Statement.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.Statement ? this.Statement.length : 1;
  },
  watch: {
    Statement(newValue) {
      if (newValue) {
        this.assignMode();
      }
    },
  },
  methods: {
    ...mapActions({
      FetchStatement: "modes/fetchStatement",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    assignMode() {
      this.modeName = this.Statement ? this.Statement[0].mode : "---";
    },
  },
  created() {
    this.FetchStatement(this.id);
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-9">
                <h4 class="card-title">
                  Statement For {{ modeName ? modeName : "Payment Method" }}
                </h4>
              </div>
              <div class="col-md-3" align="right">
                <b-button @click="$router.go(-1)" variant="primary"
                  ><i class="fa fa-undo"></i> Back</b-button
                >
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>Date From</label>
                  <input type="date" v-model="data.from" class="form-control" />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>Date To</label>
                  <input type="date" v-model="data.to" class="form-control" />
                </div>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="Statement ? Statement : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(amountin)="data">
                  {{ thousandSeperator(data.item ? data.item.in : 0) }}
                </template>
                <template #cell(amountout)="data">
                  {{ thousandSeperator(data.item ? data.item.out : 0) }}
                </template>
                <template #cell(mode_field)="data">
                  {{ data.item ? data.item.mode.name : "---" }} -
                  {{ data.item ? data.item.mode.type_name : "---" }}({{
                    data.item ? data.item.mode.account_number : "---"
                  }})
                </template>
                <template #cell(cat)="data">
                  <span v-if="data.item.type == 1">Initial Balance</span>
                  <span v-else-if="data.item.type == 2">Expense</span>
                  <span v-else-if="data.item.type == 3">Purchase</span>
                  <span v-else-if="data.item.type == 4">Sale Return</span>
                  <span v-else-if="data.item.type == 5">Purchase Return</span>
                  <span v-else-if="data.item.type == 6">CashOut</span>
                  <span v-else-if="data.item.type == 7">CashIn</span>
                  <span v-else-if="data.item.type == 8">Money Transfer</span>
                  <span v-else-if="data.item.type == 9">Customer Deposit</span>
                  <span v-else-if="data.item.type == 10">Opening Balance</span>
                  <span v-else-if="data.item.type == 11">LPO Payment</span>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
